import * as ambassadorWixPingNotificationsV3Notification from './ping-notifications-v3-notification-notifications-v-3.http.js';
import * as ambassadorWixPingNotificationsV3NotificationTypes from './ping-notifications-v3-notification-notifications-v-3.types.js';
import * as ambassadorWixPingNotificationsV3NotificationUniversalTypes from './ping-notifications-v3-notification-notifications-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function notify(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPingNotificationsV3NotificationUniversalTypes.NotifyRequest,
  ambassadorWixPingNotificationsV3NotificationTypes.NotifyRequest,
  ambassadorWixPingNotificationsV3NotificationUniversalTypes.NotifyResponse,
  ambassadorWixPingNotificationsV3NotificationTypes.NotifyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPingNotificationsV3Notification.notify(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/notify',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Notification as NotificationOriginal,
  NotifyRequest as NotifyRequestOriginal,
  DynamicValue as DynamicValueOriginal,
  DynamicValueOfTypeOneOf as DynamicValueOfTypeOneOfOriginal,
  Money as MoneyOriginal,
  MapDynamicValue as MapDynamicValueOriginal,
  ArrayDynamicValue as ArrayDynamicValueOriginal,
  AttachmentDynamicValue as AttachmentDynamicValueOriginal,
  NotifyResponse as NotifyResponseOriginal,
  NotifyByAppRequest as NotifyByAppRequestOriginal,
  Overrides as OverridesOriginal,
  TemplateChannel as TemplateChannelOriginal,
  TemplateChannelWithLiterals as TemplateChannelWithLiteralsOriginal,
  ExcludedAudiences as ExcludedAudiencesOriginal,
  ChannelsContent as ChannelsContentOriginal,
  MobileContent as MobileContentOriginal,
  ChannelsData as ChannelsDataOriginal,
  EmailData as EmailDataOriginal,
  NotifyByAppResponse as NotifyByAppResponseOriginal,
  ResolveRequest as ResolveRequestOriginal,
  ResolveResponse as ResolveResponseOriginal,
} from './ping-notifications-v3-notification-notifications-v-3.types.js';
